<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="lang">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang.planCode }}</label>
          </div>
          <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="plan_code"
            [ngClass]="formErrorClass(createForm.controls.plan_code, createFormSubmitted)">


          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.plan_code, value:createForm.controls.plan_code, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang.description }}</label>
        </div>
        <div class="form-group col-sm-9">
          <textarea class="form-control" formControlName="plan_description"
            [ngClass]="formErrorClass(createForm.controls.plan_description, createFormSubmitted)"></textarea>
       
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.plan_description, value:createForm.controls.plan_description, submitted:createFormSubmitted }">
          </ng-template>
        </div>
      </div>

      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          
          <label>{{ lang.howoftentorepeat }}</label>
        </div>
        <div class="form-group col-sm-9">
          <div class="form-group col-sm-6">
          <input type="text" class="form-control" formControlName="how_often_value"
            [ngClass]="formErrorClass(createForm.controls.how_often_value, createFormSubmitted)" maxlength="4" pattern="[0-9]+" ng-pattern-restrict>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.how_often_value, value:createForm.controls.how_often_value, submitted:createFormSubmitted }">
          </ng-template>

          </div>
          <div class="form-group col-sm-6">

          <select class="form-control" formControlName="how_often_frequency"
            [ngClass]="formErrorClass(createForm.controls.how_often_frequency, createFormSubmitted)">
            <option value="">{{ lang.select }}</option>
            <option *ngFor="let type of frequencyConfig" [ngValue]="type.value">{{type.text}}</option>
          </select>


          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.how_often_frequency, value:createForm.controls.how_often_frequency, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>
      </div>


      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang.daysnotify }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="days_notify"
            [ngClass]="formErrorClass(createForm.controls.days_notify, createFormSubmitted)" maxlength="4" pattern="[0-9]+" ng-pattern-restrict>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.days_notify, value:createForm.controls.days_notify, submitted:createFormSubmitted }">
          </ng-template>
          <div *ngIf="createForm.controls.days_notify.touched && createForm.hasError('range')" style="color: #ff7b76;">
            {{ generalLang?.daysnotifys }}
          </div>
        </div>
      </div>


      <div class="form-group col-sm-12">

        <div class="form-group col-sm-3">
          <label>{{ lang.notificationtime }}</label>
        </div>
        <div class="form-group col-sm-9">
          <select class="form-control" formControlName="notification_time"
            [ngClass]="formErrorClass(createForm.controls.notification_time, createFormSubmitted)">
            <option value="">{{ lang.selectTime }}</option>
            <option *ngFor="let mplan of this.notification_time" [ngValue]="mplan">{{mplan}}</option>
          </select>

          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.notification_time, value:createForm.controls.notification_time, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>


      <div class="form-group col-sm-12">

        <div class="form-group col-sm-3">
          <label>{{ lang.equipment_to_which_the_plan_applies }} </label>
        </div>
        <div class="form-group col-sm-9">
          <ng-multiselect-dropdown formControlName="equipment_to_which_plan" [data]="equipment_val"
            [settings]="dropdownSettings">
          </ng-multiselect-dropdown>
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.equipment_to_which_plan, value:createForm.controls.equipment_to_which_plan, submitted:createFormSubmitted }">
          </ng-template>

        </div>
      </div>

      <div class="col-sm-12" formArrayName="send_email">
        <div class="form-group col-sm-3">
          <label>{{ lang.reference_email }}</label>
        </div>
        <div class="form-group col-sm-9">
          <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
            <div class="col-sm-11">
              <input type="text" class="form-control" formControlName="{{i}}"
                [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:createFormErrorMsg.send_email, value:send_email().controls[i], submitted:createFormSubmitted }">
              </ng-template>

            </div>
            <div class="col-sm-1">
              <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
                *ngIf=" i!=(send_email().controls.length-1) ">
                <i class="fa fa-trash-o"></i>
              </button>
              <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
                *ngIf=" i==(send_email().controls.length-1) ">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>





    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <!-- <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang.close }}</button> -->
    <button type="button" class="btn btn-warning" (click)="close()">{{ lang.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>